import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/analytics';

/**
 * Component that tracks page views when the route changes
 * This should be placed as a child of the BrowserRouter in index.js
 */
const AnalyticsTracker = () => {
  const location = useLocation();
  const isInitialMount = useRef(true);
  
  useEffect(() => {
    // ✅ SKIP initial page load (already tracked in index.html)
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    
    // ✅ TRACK subsequent route changes with delay for title updates
    const trackWithDelay = () => {
      setTimeout(() => {
        trackPageView(location.pathname, document.title);
      }, 100); // 100ms delay for React Helmet title updates
    };
    
    trackWithDelay();
  }, [location]);
  
  // This component doesn't render anything
  return null;
};

export default AnalyticsTracker; 